import { FC } from 'react';
import { Box, Heading, Layout, Cell } from '@wix/design-system';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import VerticalDivider from '@components/VerticalDivider';
import BackToGalleryButton from './BackToGalleryButton';
import ReviewSummary from './HeroInfo/ReviewSummary';
import PlatformInfo from './HeroInfo/PlatformInfo';
import CreatorInfo from './HeroInfo/CreatorInfo';
import PurchaseCTAs from '../PurchaseCTAs';

import s from './Hero.module.scss';

interface Props {
  setPurchaseError: (isError: boolean) => void;
}

const Hero: FC<Props> = ({ setPurchaseError }) => {
  const { template } = useTemplateContext();

  return (
    <section>
      <Box className={s.heroContainer} height="100%">
        <Box className={s.heroContent} direction="vertical">
          <BackToGalleryButton />
          <Box direction="vertical">
            <Box width={'50%'}>
              <Heading ellipsis maxLines={2} className={s.templateHeading}>
                {template.title}
              </Heading>
            </Box>
            <Layout>
              <Cell span={8}>
                <Box marginTop="16px">
                  <CreatorInfo />
                </Box>
                <Box
                  className={s.infoContainer}
                  direction="horizontal"
                  verticalAlign="middle"
                  marginTop="14px"
                >
                  <ReviewSummary />
                  <VerticalDivider className={s.verticalDivider} />
                  <PlatformInfo />
                </Box>
              </Cell>
              <Cell span={4}>
                <Box
                  align="right"
                  verticalAlign="bottom"
                  height="100%"
                  margin-top="-4px"
                >
                  <PurchaseCTAs
                    isMobileView={false}
                    className={s.purchaseCTAsWrapper}
                    buttonSize="large"
                    setPurchaseError={setPurchaseError}
                  />
                </Box>
              </Cell>
            </Layout>
          </Box>
        </Box>
      </Box>
    </section>
  );
};

export default Hero;
